import axios from 'axios';
import Error from 'components/alerts/Error'
import React from 'react';

import { AppConfig } from '../../config/app';
import { Padding } from '../../lib/styles/Padding';

export default class ImageUpload extends React.Component<
  { [label: string]: any },
  { [label: string]: any }
  > {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      isUploading: false,
      emptyFile: false,
    };

    this.onChange = this.onChange.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  public onChange(e) {

    if (e.target.files[0].size > 1048576) {
      alert("Exceeded image size limit (1MB)!\nRecommended image resolution: 1000px x 400px");
      return undefined;
    };

    this.setState({
      file: e.target.files[0],
      imgSrc: "",
      emptyFile: false,
      isUploading: false
    });
  }
  public onSubmit(e) {
    e.preventDefault();
    this.setState({
      emptyFile: false
    });
    if (this.state.file == null) {
      this.setState({
        emptyFile: true
      });
      return;
    }
    this.setState({
      isUploading: true
    });
    this.fileUpload(this.state.file).then(response => {
      const { data } = response;
      if (data.status === "success") {
        this.setState({
          isUploading: false
        });
        this.props.onUpload(data.url);
        this.setState({ imgSrc: data.url });
      } else {
        this.setState({
          isUploading: false
        });
      }
    });
  }

  public fileUpload(file) {
    const url = AppConfig.apiUrl + "/api/upload";
    const formData = new FormData();
    formData.append("attachment", file);
    formData.append("typeOfUpload", "event-promotional");
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return axios.post(url, formData, config);
  }

  public render() {
    const { imgSrc } = this.props;
    return (
      <div className={Padding.small + "mb-2"}>
        {(imgSrc !== null && imgSrc) || this.state.imgSrc !== "" ? (
          <img
            src={imgSrc || this.state.imgSrc}
            style={{ width: this.props.logo ? "50%" : "80%", maxHeight: "240px", marginBottom: "2rem", borderRadius: '15px' }}
          />
        ) : null}
        <form onSubmit={this.onSubmit} style={{ justifyContent: 'center' }} className='file-upload-container'>
          <input
            type="file"
            onChange={this.onChange}
            className="cut-text border-0"
            style={{
              backgroundColor: '#f8f8f8', width: '150px',
              marginRight: 'auto', marginLeft: 'auto'
            }}
          />
          <br />
          <button
            className="new-button-white-4"
            disabled={this.state.isUploading}
          // style={{
          //   border: 'none', float: 'right', backgroundColor: '#4d5ae9', color: '#f8f8f8'
          // }}
          >
            {this.state.isUploading ? "UPLOADING..." : "UPLOAD"}
          </button>
        </form>
        {this.state.emptyFile ? <div style={{ paddingTop: '110px' }}><Error content="Please choose file first" /></div> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/upload/ImageUpload.tsx